<script setup lang="ts">
type PropsType = {
  content: {
    topContent: string;
  };
};

const props = defineProps<PropsType>();

const topContent = computed(() => props.content.topContent);

const { radio } = form();

function form() {
  const radio = ref(true);

  return {
    radio,
  };
}
</script>

<template>
  <div class="compaints_handling">
    <div class="rich-text">
      <BaseRichText :content="topContent" />
    </div>

    <div class="form-group max-w-[730px]">
      <div class="form-field">
        <h4 class="font-semibold text-sm my-4">All Fields are Mandatory</h4>

        <div class="space-y-[18px]">
          <input type="text" placeholder="First Name" />
          <input type="text" placeholder="Last Name" />
          <input type="text" placeholder="Preffered Contact Number" />
          <input type="text" placeholder="Email" />
        </div>

        <div class="radios">
          <p>I am a Catch Connect Customer*</p>

          <label for="yes">
            <input id="yes" v-model="radio" type="radio" :value="true" />
            <span class="ml-2">Yes</span>
          </label>
          <label for="no">
            <input id="no" v-model="radio" type="radio" :value="false" />
            <span class="ml-2">No</span>
          </label>
        </div>

        <div class="account-dropdown mb-4">
          <select id="" name="" class="appearance-none text-black">
            <option disabled selected>
              Which account are you experiencing issues with?
            </option>
            <option value="account-1">Account 1</option>
            <option value="account-2">Account 2</option>
          </select>
        </div>

        <div class="notes">
          <p class="mb-2 text-sm">
            Description of issue * [Please provide as much information as
            possible to assist. Do not include any sensitive information eg bank
            details] 2000 character limit
          </p>

          <textarea
            class="h-[60px] leading-[1.5]"
            cols="30"
            rows="10"
          ></textarea>
        </div>

        <div class="terms">
          <label for="terms">
            <input id="terms" type="checkbox" />
            <span>
              I agree with the terms of the
              <NuxtLink to="#">Catch Connect Privacy Policy</NuxtLink>
            </span>
          </label>
        </div>

        <div class="footer-content">
          <p class="mb-4 text-sm">
            We aim to get back to you within 2 business days.
          </p>

          <p class="text-sm">
            If you are dealing with an urgent issue such as financial hardship ,
            disconnection of your service, or if a disconnection is about to
            occur, please call us on 1300 222 825.
          </p>

          <button class="btn btn-primary green semi-rounded my-4">
            submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rich-text {
  :deep() {
    h2 {
      @apply mt-0;
    }
  }
}

.radios {
  @apply flex flex-col items-start my-4;

  p {
    @apply mb-4 text-sm;
  }

  label {
    @apply mb-0 flex items-baseline;

    input[type="radio"] {
      @apply focus:ring-transparent focus:shadow-none focus:outline-none focus:border-transparent mb-0;
    }

    span {
      @apply ml-2;
    }
  }
}

.terms {
  @apply mb-4;

  label {
    @apply inline-flex items-center justify-start gap-3;

    input[type="checkbox"] {
      @apply w-auto focus:ring-transparent focus:shadow-none focus:outline-none focus:border-transparent;
    }

    span {
      @apply text-sm;

      a {
        @apply text-primary text-sm;
      }
    }
  }
}
</style>
